import bg from '../assets/bg.webp'
import logo from '../assets/logo.webp'
import stroke from '../assets/stroke-top.webp'
import hari from '../assets/hari.webp'

import {BsWhatsapp, BsInstagram} from 'react-icons/bs'
import {MdAlternateEmail} from 'react-icons/md'

import Card from '../components/Card'
import Nav from '../components/Nav'

import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Home = () => {

    const placeholder = `https://picsum.photos/600/300`

    const cards =[
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
        {"img":placeholder, "name":"Art is Art", "desc":"Art is not just Art", "price":"6770" },
    ]
    const [scrollY, setScrollY] = useState(0);
    const [blurValue, setBlurValue] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > scrollY) {
            setBlurValue(currentScrollY/50);
        } else {
            setBlurValue(currentScrollY/100);
        }
        setScrollY(currentScrollY);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollY]);

    const divStyle = {
    filter: `blur(${blurValue}px)`,
    transition: 'filter ease-in-out',
    }

    return(
        <div>
            <Nav/>
            <div id='home' className='fixed h-screen w-screen overflow-hidden '>
                <div  style={divStyle} className='absolute centerv text-center m-auto flex flex-col justify-center items-center w-full z-[1]'>
                    <img className='w-[10rem] -mt-16 md:w-[14rem] mix-blend-difference' alt='' src={logo} />
                    <div className='scale-[80%] md:scale-[100%]'>
                        <h1 className='mt-6 text-red-900 text-5xl kha font-medium tracking-[9px]'>HARIRANG</h1>
                        <p className='text-red-900 mt-1 uppercase text-sm md:text-md tracking-[6px]'>The colours of the Divine</p>
                    </div>
                </div>
                <img className='h-screen w-screen object-cover opacity-90' alt='' src={bg} />
            </div>
            <div className='h-screen w-full'>
                <br></br>
            </div>
            <div id='about' className='relative mt-12 mb-48 drop-shadow-xl py-8 p-6  md:w-1/2 m-auto rounded-b-[80rem] md:rounded-b-[2rem] rounded-t-full md:rounded-t-[2rem] bg-white text-black'>
                <h2 className='text-center p-3 px-6 bg-white rounded-full centerh absolute drop-shadow-xl uppercase text-xs text-yellow-600 -top-6 pc'> About the Artist</h2>
                    <img className='rounded-full m-auto w-[20rem] md:my-4 bg-white drop-shadow-2xl p-2 grayscale-0 pointer-events-auto hover:p-3 anim hover:grayscale' alt='' src={hari} />
                <h1 className='text-2xl md:text-3xl pf text-center uppercase tracking-widest text-red-900 my-6'>Harsiddhiba gohil</h1>
                <p className='w-11/12 text-center m-auto'>
                I am an artist born in a country which has rich culture and art. As I'm very influenced by my Indian
                history and culture, I always wants to be great Indian artist. Basically i am oil paintings artist but
                with that also doing many of artworks like string art, embose work , Mud Art, clay work etc.
                most of my works are done on portraits.belongs to the great Hindu religion I also works on the
                Indian history which explains Dharma , Indian society and incredible india. 
                </p>
                <a href='#contact' className='bg-red-900 text-center my-8 text-white rounded-full block m-auto w-1/2 md:w-fit px-6 p-4'>Contact Me</a>
            </div>
            
            <div id='projects' className='relative drop-shadow-2xl bg-white w-full '>
                <img className='absolute h-16 w-screen object-cover  -top-16' alt='' src={stroke} />
                <img className='absolute h-16 w-screen object-cover -bottom-16 rotate-180' alt='' src={stroke} />
                <h2 className='pf text-red-900 text-center py-8 text-3xl'>Artworks</h2>
                {/* <img className='absolute mix-blend-difference w-screen object-cover md:object-contain -top-[2rem] md:-top-[10rem]' src={stroke}/> */}
                <div className='flex gap-6 overflow-scroll pt-24 py-12 scroll-p-12 w-full'>

                {
                    cards.map((card, index) => (
                        <Card key={index} img={card.img} name={card.name} desc={card.desc} price={card.price} />
                    ))
                }
                </div>
                <Link to='/projects' className='bg-red-900 text-white text-center rounded-full block m-auto w-1/2 md:w-fit px-6 p-4'>View All</Link><br/>
            </div>

            <div id='vision' className='relative my-48 drop-shadow-xl py-8 p-6 w-11/12 md:w-1/2 m-auto rounded-3xl bg-white text-black'>
                <h2 className='text-center p-3 px-6 bg-white rounded-full centerh absolute drop-shadow-xl uppercase text-xs text-yellow-600 -top-6'> Vision & Mission</h2>
                <p className='w-11/12 my-6 text-center m-auto'>The tagline <br/><span className='text-yellow-500 text-lg uppercase'>"the colours of divine"</span><br/> has been thoughtfully chosen as it perfectly captures the
                essence of the artist's work. The artist's creations are a reflection of India's rich cultural heritage,
                Mythology, Divinity and Spirituality, all of which are steeped in vibrant hues that have been passed
                down through generations. By harnessing the power of these divine colors, the artist aims to spread
                the knowledge of India's rich cultural tapestry across the globe. This endeavor is a tribute to the
                country's timeless traditions and a celebration of its spiritual essence.
                </p>
            </div>

            <div id='contact' className='bg-white w-full p-6 relative'>
                <p className='text-center font-medium mt-4 text-red-900'>Contact me</p>
                <div className='flex gap-6 m-auto w-full justify-center items-center my-8'>
                    <a href='https://'> <BsWhatsapp color='brown' size='25px'/> </a>
                    <a href='https://'> <BsInstagram color='brown' size='25px'/> </a>
                    <a href='https://'> <MdAlternateEmail color='brown' size='25px'/> </a>
                </div>
            </div>

        </div>
    )
}

export default Home;